/**
 * PresencePage.tsx (service technique) — Bloc 1B.
 *
 * Onglet « Présence » du module Service technique : monte le composant unifié
 * PlanningPresence (vue équipe / personne / année). Le second onglet « Planning
 * de travail » (drag signalements) reste la page existante et sera refondu au
 * Bloc 2. Ici on ajoute uniquement la présence, réutilisable partout.
 */

import { useState } from 'react';
import { AppHeader } from '@/components/AppHeader';
import { useAuth } from '@/lib/auth-context';
import { api } from '@/lib/api';
import { PlanningPresence } from '@/components/planning/PlanningPresence';
import { ServiceTechniqueTabs } from '@/pages/service-technique/ServiceTechniqueTabs';
import { ServiceTechniqueAgentTabs } from '@/pages/service-technique/ServiceTechniqueAgentTabs';
import { DeclarerAbsenceModal } from '@/pages/service-technique/DeclarerAbsenceModal';
import { useToast } from '@/components/ui/Toast';

export function PresenceServiceTechniquePage() {
  const { user } = useAuth();
  const { toast } = useToast();
  const peutDeclarer = user?.role === 'manager' || user?.role === 'admin' || user?.role === 'super_admin';
  const [absModal, setAbsModal] = useState<{ agent: { id: string; fullName: string }; jourISO: string } | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="min-h-screen bg-bg">
      <AppHeader module="Service technique" accent="tech" />
      {user?.role === 'agent' ? (
        <ServiceTechniqueAgentTabs active="presence" />
      ) : (
        <ServiceTechniqueTabs active="presence" />
      )}
      <main className="mx-auto max-w-[1400px] px-4 py-5">
        <h1 className="mb-4 text-lg font-bold text-ink">{user?.role === 'agent' ? 'Ma présence' : "Présence de l'équipe"}</h1>
        <PlanningPresence
          key={reloadKey}
          accent="tech"
          role={user?.role ?? 'agent'}
          currentUserId={user?.id ?? ''}
          loadWeek={(weekStart) => api.serviceTechnique.planning.getWeek(weekStart)}
          loadAnnee={(annee, agentId) => api.serviceTechnique.planning.annee(annee, agentId)}
          loadCompteurs={(annee, agentId) => agentId ? api.rh.compteursAgent(agentId, annee) : api.rh.mesCompteurs(annee)}
          onDeclareAbsence={peutDeclarer ? (agent, jourISO) => setAbsModal({ agent, jourISO }) : undefined}
        />
      </main>

      {absModal && (
        <DeclarerAbsenceModal
          agent={absModal.agent}
          jourISO={absModal.jourISO}
          service="service_technique"
          onClose={() => setAbsModal(null)}
          onDone={(conflits) => {
            setAbsModal(null);
            setReloadKey((k) => k + 1);
            toast.success(conflits > 0
              ? `Absence enregistrée. ${conflits} tâche(s) à réaffecter — responsable alerté.`
              : 'Absence enregistrée.');
          }}
        />
      )}
    </div>
  );
}
